import { get } from 'lodash'

export const getObjectiveIdVars = context => ({
  id: {
    codDistribuidor: get(context, 'currentUser.codDistribuidor'),
    ano: get(context, 'objective.ano'),
    codObjetivo: get(context, 'objective.codObjetivo'),
  },
})
